import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import { monthArray } from "../constants/commonConstants";

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatOrderCreatedDate = (dateString) => {
  //dayjs(dateString).format("MMM D, hh:mm A");
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("MMM D, hh:mm A");
};

export const formatYYYY_MM_DD = (dateString) => {
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("YYYY-MM-DD");
};

export const formatYYYY_MM_DD_HH_MM_A = (dateString) => {
  
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs
    .utc(dateString)
    .tz(dayjs.tz.guess())
    .format("YYYY-MM-DD hh:mm A");
};

export const formatDD_MM_YYYY_HH_MM = (dateString) => {
  
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs
    .utc(dateString)
    .tz(dayjs.tz.guess())
    .format("DD/MM/YYYY HH:mm");
};

export const formatHH_MM_SS = (dateString) => {
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs.utc(dateString).tz(dayjs.tz.guess()).format("hh:mm A");
};

export const formatPaymentDate = (dateString) => {
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs
    .utc(dateString)
    .tz(dayjs.tz.guess())
    .format("MMMM D, YYYY, h:mm A");
};

export const formatChatDate = (dateString) => {
  if (!dateString || isNaN(new Date(dateString))) return "-";

  // Parse the input date and convert to local timezone
  const messageDate = dayjs.utc(dateString).tz(dayjs.tz.guess());
  const now = dayjs();

  // Start of today and yesterday (local time)
  const startOfToday = now.startOf("day");
  const startOfYesterday = now.subtract(1, "day").startOf("day");

  // Check if the date falls within today or yesterday
  if (messageDate.isAfter(startOfToday)) return "Today";
  if (messageDate.isAfter(startOfYesterday)) return "Yesterday";

  // For all other dates, return formatted date
  return messageDate.format("MMMM DD, YYYY");
};


export const formatIndicatorDate = (dateString) => {
  //checks for valida js dates
  if (!dateString || isNaN(new Date(dateString))) {
    return "-";
  }

  return dayjs
    .utc(dateString)
    .tz(dayjs.tz.guess())
    .format("YYYY/MM/DD hh:mm A");
};

// format date to ISO string in UTC timezone for filtering
export const formatDateToISO = (date, isEndDate = false) => {
  if (!date) return undefined;
  
  // Create a new Date object to avoid mutating the original
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return undefined;
  
  // Get the date components in the original timezone
  const year = parsedDate.getFullYear();
  const month = parsedDate.getMonth();
  const day = parsedDate.getDate();
  
  // Create a new date in UTC for the same calendar date
  const utcDate = new Date(Date.UTC(year, month, day));
  
  if (isEndDate) {
    // Set to end of day in UTC: 23:59:59.999
    utcDate.setUTCHours(23, 59, 59, 999);
  } else {
    // Set to start of day in UTC: 00:00:00.000
    utcDate.setUTCHours(0, 0, 0, 0);
  }
  
  return utcDate.toISOString();
};

export const formatMonthToDateRange = (monthString) => {
  if ( typeof monthString === 'string' && monthArray.includes(monthString)) {
    const monthIndex = monthArray.indexOf(monthString);
    const today = new Date();
    const thisMonthIndex = today.getMonth();
    let  year = today.getFullYear();

    if (monthIndex - thisMonthIndex > 0 ) {
      // consider as a past month selection
      year = year - 1;
    }
    const startDate = new Date(year, monthIndex, 1);
    const endDate = new Date(year, monthIndex + 1, 0);
    
    return {
      startDate: formatYYYY_MM_DD(startDate),
      endDate: formatYYYY_MM_DD(endDate),
    };
  }

  return {
    startDate: "",
    endDate: ""
  };
};